export default __webpack_public_path__ + "static/media/referrer.3fe44ec2.png";